import { DashboardProvider } from './Context/DashboardContext';
import DashboardContent from './DashboardContent';

export default function DashboardBeta() {
  return (
    <DashboardProvider>
      <DashboardContent />
    </DashboardProvider>
  );
}
